export const maritalStatusItems = [
  { id: 1, name: 'Solteiro(a)' },
  { id: 2, name: 'Casado(a)' },
  { id: 3, name: 'Divorciado(a)' },
  { id: 4, name: 'Viúvo(a)' },
  { id: 5, name: 'Separado(a)' },
  { id: 6, name: 'Companheiro(a)' },
];
